import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { InstalacionDireccion } from 'src/app/global/interfaces/instalacion-direccion';
import { InstalacionDireccionService } from 'src/app/global/services/instalacion-direccion.service';
import { InstalacionDireccionServiceVM } from 'src/app/view-model/services/instalacion-direccion.service';


@Injectable()
export class InstalacionDireccionProviderVM extends InstalacionDireccionServiceVM {


    constructor(private instalacionDireccionService: InstalacionDireccionService) {
        super();
    }


    obtenerDireccionInstalacion(): Observable<InstalacionDireccion> {

        return this.instalacionDireccionService.obtenerDireccionInstalacion()
            .pipe(map(this.obtenerDireccionInstalacionOK), catchError(this.serviceError));

    }

    private obtenerDireccionInstalacionOK(resp) {
        return resp;
    }



    actualizarDireccionInstalacion(direccion: InstalacionDireccion): Observable<any> {

        return this.instalacionDireccionService.actualizarDireccionInstalacion(direccion)
            .pipe(map(this.actualizarDireccionInstalacionOK), catchError(this.serviceError));
    }

    private actualizarDireccionInstalacionOK(resp) {
        return resp;
    }

    private serviceError(error) {
        return throwError(error);
    }
}
